module.exports = __webpack_public_path__ + "static/control-cdf1626c904c6e0f3c3a35291943314e.png";